import { getUpgradeData } from "libs/item";
import UpgradeIcon from "./UpgradeIcon";

interface ItemProps {
  slug: string;
}

const ItemIcon = ({ slug }: ItemProps) => {
  const upgrade = getUpgradeData(slug) || null;

  if (!!upgrade) {
    return <UpgradeIcon slug={slug} />;
  }

  return <></>;
};

export default ItemIcon;
